import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { Namespace } from '../../../translation/namespace';

type PageTypeDescriptionProps = {
  pageType: string;
};
export function PageTypeDescription({ pageType }: PageTypeDescriptionProps) {
  const { t, i18n } = useTranslation(Namespace.PageType);
  /* eslint-disable react/jsx-key */
  /* mixed language here, translation needed to add span for language attribute. wrapper span for correct design! */
  return (
    <span className="page-type-icon__description">
      <Trans t={t} i18nKey={`${pageType}.description`} i18n={i18n} components={[<span lang="en">value</span>]} />
    </span>
  );
  /* eslint-enable react/jsx-key */
}
